export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/financial-design-cheatsheet-22e52030b6f68d8216e32a2763fb759e.png";